module.exports = __webpack_public_path__ + "public/SiteIcons/verifiFacebook.png?ca995822";